module.exports = __webpack_public_path__ + "img/peixe.3df08835.svg";